import { FABRIC_CAPTURE_THRESHOLDS } from '../constants/thresholds';

/**
 * @param {number} coverageRatio
 * @param {typeof FABRIC_CAPTURE_THRESHOLDS} [t]
 * @returns {import('../types').DistanceState}
 */
export function distanceStateFromCoverage(coverageRatio, t = FABRIC_CAPTURE_THRESHOLDS) {
  if (coverageRatio > t.tooCloseCoverageThreshold) return 'too_close';
  if (coverageRatio < t.tooFarCoverageThreshold) return 'too_far';
  if (coverageRatio >= t.idealMinCoverage && coverageRatio <= t.idealMaxCoverage) return 'good';
  return 'adjust';
}

/**
 * @param {import('../types').DistanceState} state
 * @returns {string}
 */
export function distanceStateLabel(state) {
  switch (state) {
    case 'too_close':
      return 'Too close';
    case 'too_far':
      return 'Too far';
    case 'good':
      return 'Good distance';
    case 'adjust':
    default:
      return 'Adjust framing';
  }
}
